import { render, staticRenderFns } from "./SoundRightsRecordManager.vue?vue&type=template&id=4b93f181&scoped=true"
import script from "./SoundRightsRecordManager.vue?vue&type=script&lang=js"
export * from "./SoundRightsRecordManager.vue?vue&type=script&lang=js"
import style0 from "./SoundRightsRecordManager.vue?vue&type=style&index=0&id=4b93f181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93f181",
  null
  
)

export default component.exports